module.exports = __webpack_public_path__ + "img/logo.fdd14148.png";